import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
	resetUnitRequested,
	setActiveKey,
} from '../../../../redux/myCourse/myCourse.actions';
import { htmlDecode } from '../../../../utils/commonFunctions';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Accordion from 'react-bootstrap/Accordion';
import ElementList from '../elements';

import ListAnimation from '../../../utils/animations/list';
const mapStateToProps = (state) => {
	const {
		units,
		requestedUnit,
		currentUnitOrder,
		coursedetails: { course_id },
		activeUnit,
		addedGrants
	} = state.rootReducer.myCourse;
	return {
		units,
		requestedUnit,
		currentUnitOrder,
		course_id,
		activeUnit,
		addedGrants
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		resetUnitRequested: () => dispatch(resetUnitRequested()),
		setActiveKey: (val) => dispatch(setActiveKey(val)),
	};
};

const UnitTabHeader = ({
	units,
	requestedUnit,
	currentUnitOrder,
	resetUnitRequested,
	setActiveKey,
	course_id,
	activeUnit,
	addedGrants,
	elementFilter,
}) => {

	useEffect(() => {
		return () => {
			if (
				requestedUnit > -1 &&
				!parseInt(sessionStorage.getItem('activeSessionUnit'), 10)
			) {
				resetUnitRequested();
			}
		};
	}, [resetUnitRequested, requestedUnit]);

	useEffect(() => {
		setActiveKey(
			requestedUnit > -1 ? parseInt(requestedUnit) : parseInt(currentUnitOrder),
		);
	}, [currentUnitOrder, requestedUnit, setActiveKey]);

	return (
		<ListAnimation>
			{!!units &&
				Object.keys(units).map((unit, index) => {

					const {
						course_elements,
						unit_name,
						completed_activites,
						total_activites,
					} = units[unit];
					const filteredCourse = course_elements.filter((x) =>
						!!elementFilter && elementFilter.toLowerCase() !== 'any'
							? x.element_theme === elementFilter
							: x,
					);

					const percentComplete = Math.round(
						(completed_activites * 100) / total_activites,
					);

					return (
						<Accordion
							key={parseInt(unit, 10)}
							activeKey={activeUnit}
							onSelect={() =>
								setActiveKey(
									activeUnit === parseInt(unit, 10) ? -1 : parseInt(unit, 10),
								)
							}
						>
							<Card className={Object.keys(units).length === (index + 1) ? 'add-botborder-to-list' : ''}>
								<Accordion.Toggle
									id={`unit_${course_id}_${unit}`}
									as={Card.Header}
									className=""
									eventKey={parseInt(unit, 10)}
								>
									<div className="unitHeader justify-between">
										<div className='unitHeader-Title'>
											<h1>{htmlDecode(unit_name)}</h1>
											{course_id != 507 ? (
												<div className="display-flex justify-between">
													{/* <h4 className="unitProgress">
														{completed_activites} of {total_activites} Activities
													</h4> */}
													<div className={`divProgress ${(percentComplete === 0) ? 'hideElement' : ''}`}>
														<span
															className="progpercent"
															style={{ width: percentComplete + '%' }}
														></span>
														<span className="progpercenttext"></span>
													</div>
												</div>
											) : null}
										</div>
										<div className='unitHeader-tools'>
											{percentComplete === 100 &&
												<img src="/assets/img/payment_success.gif" alt="Unit completed successfully" className='unit-success-img' />
											}

											{/* <a href='javascript:void(0)' title='Sort Activities' onClick={(e) => { e.preventDefault(); getThisObject(); }}>Sort By Status</a>
											<a href='javascript:void(0)' title='Go to previous unit'>Previous</a>
											<a href='javascript:void(0)' title='Go to next unit'>Next</a>
											<span className='btn-seperator'>|</span> 
											<a href='javascript:void(0)' title='Toggle this unit' className=''>Toggle</a> */}
										</div>
									</div>
								</Accordion.Toggle>
								<Accordion.Collapse eventKey={parseInt(unit, 10)}>
									<Card.Body className='unitBody-CardBody'>
										{!!filteredCourse && filteredCourse.length > 0 ? (
											<div className="elementsContainer">
												{filteredCourse.map((elementDetails, idx) => (
													<ElementList
														key={elementDetails.elementID}
														elementDetails={elementDetails}
														unitName={index === 0 ? 'Start' : (index === (Object.keys(units).length - 1) ? 'Certification' : '')}
													/>
												))}
											</div>
										) : (
											<p className="no-activity">
												No Activities in this Unit that match your "I want to..." preference
												above.
											</p>
										)}
									</Card.Body>
								</Accordion.Collapse>
							</Card>
						</Accordion>
					);
				})}
		</ListAnimation>
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(UnitTabHeader);
